import i18n from '@/i18n'

export default [
  {
    path: '/tasks',
    meta: {
      title: i18n.t('menu.cacheRefresh'),
      leftMenuCode: 'Configurations'
    },
    component: () => import('@/views/tasks/index.vue')
  },
  {
    path: '/tasks/add',
    meta: {
      title: i18n.t('menu.taskCreation'),
      leftActiveIndex: '/tasks',
      leftMenuCode: 'Configurations',
      backable: true
    },
    component: () => import('@/views/tasks/add.vue')
  }
]
